<template>
  <div
    class="tw:max-w-[310px] tw:whitespace-normal tw:text-left tw:shadow-[2px_2px_4px_0px_rgba(0,0,0,0.25)] tw:bg-white tw:rounded-xl tw:p-4 tw:border tw:border-gray-300"
  >
    <div class="tw:flex tw:items-center tw:gap-4">
      <div
        class="tw:bg-decorative-orange tw:w-[40px] tw:h-[40px] tw:flex tw:justify-center tw:items-center tw:rounded-full"
      >
        <img :src="item.icon" :alt="$t(item.title)" class="tw:w-[24px] tw:h-[24px]" />
      </div>
      <h2 class="tw:font-bold tw:leading-4">{{ $t(item.title) }}</h2>
    </div>
    <ul class="tw:mt-3 tw:list-disc tw:ml-6 tw:flex tw:flex-col tw:gap-2">
      <li v-for="benefit in item.benefits" :key="benefit" v-html="$t(benefit)"></li>
    </ul>
  </div>
</template>

<script setup>
defineProps({
  item: {
    type: Object,
    required: true,
  },
})
</script>
